import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=1fb46976&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"
import style0 from "./customer.vue?vue&type=style&index=0&id=1fb46976&lang=scss&scoped=true&"
import style1 from "./customer.vue?vue&type=style&index=1&id=1fb46976&lang=scss&scoped=true&"
import style2 from "./customer.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb46976",
  null
  
)

export default component.exports